import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import '../../../../assets/scss/plugins/ui/react-quill.scss';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage } from 'react-intl';

const TextEditorField = ({
  object,
  locale,
  setter,
  forwardedPropertyName,
  messageId,
  enableLinks,
}) => {
  const propertyName =
    forwardedPropertyName || `description${locale?.toUpperCase() || ''}`;

  const [value, setValue] = useState(object[propertyName] || '');

  const onChange = (newEditorState) => {
    setValue(newEditorState);
    if (setter) {
      setter({
        ...object,
        [propertyName]: newEditorState,
      });
    }
  };

  useEffect(() => {
    if (object) {
      setValue(object[propertyName]);
    }
  }, [object, propertyName]);

  const toolbar = [['bold', 'italic', 'underline', enableLinks && 'link']];

  return (
    <AvGroup className="form-label-group">
      <span
        className="primary"
        style={{
          padding: '0.25rem 0',
          fontSize: '0.7rem',
          left: '3px',
          position: 'absolute',
          top: '-20px',
        }}
      >
        <FormattedMessage id={messageId || propertyName} />
      </span>
      <ReactQuill
        data-testid="textInputFieldQuill"
        modules={{ toolbar }}
        theme="snow"
        className="bg-transparent font-small-3 line-height-15"
        value={value}
        onChange={onChange}
      />
    </AvGroup>
  );
};

export default TextEditorField;
